export default "__VITE_ASSET__C9NCSODG__"